import { Row, Col, Form, Input, Typography, Space } from "antd";

import { AttachFile } from "../../../../../../../components";
import {
  Position,
  PositionCode,
  RegExp,
  Rules,
} from "../../../../../../../constants";
import { StringHelper } from "../../../../../../../helper";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { isInGroup } from "../../../pages/absence-letter/absence-letter-create";
import VacationPeriodList from "../../vacation-period-list";

interface Props {
  userInfo?: any;
  data?: any;
}

const { Text } = Typography;

// function calculateEndDate(startDate: Moment, daysNumber: number): Moment {
//   const startDateClone = startDate.clone();
//   let daysToAdd = 0;
//   while (daysToAdd < daysNumber) {
//     if (startDateClone.day() !== 0 && startDateClone.day() !== 6) {
//       daysToAdd++;
//     }
//     startDateClone.add(1, "days");
//   }
//   const endDate = startDateClone.subtract(1, "days");
//   return endDate;
// }

export const ApplicationForLeaveForm = ({ userInfo, data }: Props) => {
  const form = Form.useFormInstance();
  // const [dates, setDates] = useState<[Moment, Moment] | null>(null);

  const ePosition = Form.useWatch("ePosition", form);
  // const eRemainingAnnualLeave = Form.useWatch("eRemainingAnnualLeave", form);
  // const eVacationPeriod = Form.useWatch("eVacationPeriod", form);

  const [position] = StringHelper.verticalBarSplit<[Position]>(
    ePosition ?? data?.ePosition
  );

  const isHeadDepartment = isInGroup(position ?? "", [
    PositionCode.TP,
    PositionCode.TTT,
  ]);

  // const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  //   if (!eRemainingAnnualLeave) return true;
  //   if (!current || !dates || (eVacationPeriod?.[0] && eVacationPeriod?.[1])) {
  //     return false;
  //   }
  //   const endDate = calculateEndDate(
  //     dates[0].startOf("day"),
  //     Math.round(eRemainingAnnualLeave)
  //   );
  //   return current && current >= endDate.endOf("day");
  // };

  // const onCalendarChange = (
  //   dates: any,
  //   _: any,
  //   info: { range: "start" | "end" }
  // ) => {
  //   if (info.range === "start" && dates?.[0]) {
  //     setTimeout(() => {
  //       form.setFieldValue("eVacationPeriod", [dates[0], null]);
  //     }, 0);
  //   }
  //   setDates(dates);
  // };

  return (
    <Row gutter={[16, 0]}>
      <Col span={24}>
        <Form.Item name="eFileContent">
          <AttachFile>
            <Space style={{ fontSize: 15 }}>
              Chứng từ đính kèm
              <AiOutlineCloudUpload size={24} />
              (word, excel, pdf, jpg,...)
            </Space>
          </AttachFile>
        </Form.Item>
      </Col>
      <Col xs={24} md={12} xl={6}>
        <Form.Item
          label={
            <Text
              ellipsis={{ tooltip: "Nghỉ phép lần thứ bao nhiêu trong năm" }}
            >
              Nghỉ phép lần thứ bao nhiêu trong năm
            </Text>
          }
          name="eAnnualLeaveTimes"
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={12} xl={6}>
        <Form.Item
          label="Email"
          name="eEmail"
          rules={[
            { pattern: RegExp.email, message: "Định dạng phải là email" },
          ]}
        >
          <Input />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item
          required
          label="Thời gian xin nghỉ phép"
          name="eVacationPeriod"
        >
          <VacationPeriodList />
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item
          label="Nơi nghỉ phép"
          name="eLeavePlace"
          rules={[Rules.required("Vui lòng nhập trường này!")]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item
          label="Số điện thoại liên lạc"
          name="ePhoneNumber"
          rules={[
            Rules.required("Vui lòng nhập trường này!"),
            {
              pattern: RegExp.vnPhoneNumber,
              message: "Định dạng phải là số điện thoại!",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Col>
      {isHeadDepartment && (
        <>
          <Col span={12}>
            <Form.Item
              label="Giấy ủy quyền số"
              name="eProxyLetterNumber"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập trường này!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Ủy quyền cho"
              name="eProxyFor"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập trường này!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </>
      )}
      <Col span={24}>
        <Form.Item
          label="Lý do"
          name="eReason"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập trường này!",
            },
          ]}
        >
          <Input.TextArea />
        </Form.Item>
      </Col>
    </Row>
  );
};
